import { memo } from "react";
import { Navigate, useParams } from "react-router-dom";
import { MediaDataRoom } from "features/mediaDataRoom";

const MediaDataRoomPage = memo(() => {
  const { dataRoomId } = useParams();
  if (!dataRoomId) {
    return <Navigate replace={true} to="/datarooms" />;
  }
  return <MediaDataRoom dataRoomId={dataRoomId} />;
});
MediaDataRoomPage.displayName = "MediaDataRoomPage";

export default MediaDataRoomPage;
